var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    color: "#8E8E8E",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1171 2.5C15.2346 2.5 16.3096 2.94167 17.1005 3.73417C17.8921 4.525 18.3346 5.59167 18.3346 6.70833V13.2917C18.3346 15.6167 16.443 17.5 14.1171 17.5H5.88464C3.5588 17.5 1.66797 15.6167 1.66797 13.2917V6.70833C1.66797 4.38333 3.55047 2.5 5.88464 2.5H14.1171ZM15.443 7.95L15.5096 7.88333C15.7088 7.64167 15.7088 7.29167 15.5005 7.05C15.3846 6.92583 15.2255 6.85 15.0596 6.83333C14.8846 6.82417 14.718 6.88333 14.5921 7L10.8346 10C10.3513 10.4008 9.6588 10.4008 9.16797 10L5.41797 7C5.1588 6.80833 4.80047 6.83333 4.58464 7.05833C4.35964 7.28333 4.33464 7.64167 4.52547 7.89167L4.63464 8L8.4263 10.9583C8.89297 11.325 9.4588 11.525 10.0513 11.525C10.6421 11.525 11.218 11.325 11.6838 10.9583L15.443 7.95Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIc);
export default __webpack_public_path__ + "static/media/mail_ic.b2fc58e00aaf98c49689f9006e73c823.svg";
export { ForwardRef as ReactComponent };